import React, { useEffect } from 'react';
import ImageTestType from '../../Assets/tipo-teste.png';
import GroupButtom from '../../Component/Buttom/group-buttom';
import { Conteiner, Item, MainConteiner } from '../../Component/Conteiner/conteiner';
import Inform from '../../Component/Inform/inform';
import { api } from '../../Services/drogal-api';
import './test-type.scss';

const TestType = ({show, onClick, onTestClick, onClick1, onClick2, onClick3, onClick4, onClick5}) => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    return (
        show ?
        <>
            <MainConteiner>
                <Item className="test-display-inform-mobile">
                    <Inform 
                        param2={ true }
                        param3={ true }
                        onClick1={ onClick1 } 
                        onClick2={ onClick2 } 
                        onClick3={ onClick3 } 
                        onClick4={ onClick4 }
                        onClick5={ onClick5 }
                    />
                </Item>
                <Item className="test-display-inform-mobile">
                    <GroupButtom  onWhatsClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}} />
                </Item>                
            </MainConteiner>
            <div style={{textAlign:'center'}}>
                
                <MainConteiner>
                    <Item>
                        <img className="image-test-type fadeIn" src={ ImageTestType }/>
                        <Conteiner>
                            <Item  style={{maxWidth:'350px'}}>
                                <strong className="test-title-font-size"><mark className="test-type-mark-color">Teste de coronavírus antígeno</mark></strong>
                                <p className="test-font-size test-font-margin">

                                    O teste rápido por antígeno tem a finalidade 
                                    detectar a presença ou não de partículas do 
                                    vírus (antígenos) causador da COVID-19. Possui 
                                    duas opções o swab (cotonete) que é realizado 
                                    através da secreção nasal e o Ag Oral Saliva que 
                                    é realizado através de uma amostra oral, ideal 
                                    para crianças com coleta não invasiva. O resultado 
                                    fica pronto em até 15 minutos. Swab é indicado para 
                                    quem teve exposição recente ao vírus. É necessário 
                                    que o paciente tenha ao menos 3 dias de sintomas ou 
                                    5-6 dias de contato com pessoa testada positivamente para a 
                                    realização do teste. Já o Ag Oral Saliva é recomendado 
                                    para pacientes sintomáticos com 1 a 7 dias de sintomas.
                                    {/* O teste rápido por antígeno tem a finalidade 
                                    detectar a presença ou não de partículas do 
                                    vírus (antígenos) causador da COVID-19. Possui 
                                    duas opções o swab (cotonete) que é realizado 
                                    através da secreção nasal e o Ag Oral Saliva que 
                                    é realizado através de uma amostra oral, ideal 
                                    para crianças com coleta não invasiva. O resultado 
                                    fica pronto em até 15 minutos. Swab é indicado para
                                    quem teve exposição recente ao vírus. É necessário 
                                    que o paciente tenha ao menos 3 dias de sintomas ou 
                                    do contato com pessoa testada positivamente para a 
                                    realização do teste. Já o Ag Oral Saliva é 
                                    recomendado para pacientes sintomáticos com 1 a 7 
                                    dias de sintomas. */}

                                    {/* O teste rápido por antígeno tem a finalidade
                                    detectar a presença ou não de partículas do
                                    vírus (antígenos) causador da COVID-19.
                                    É realizado com swab (cotonete) através da
                                    secreção nasal. O resultado fica pronto em até
                                    15 minutos. Indicado para quem teve exposição
                                    recente ao vírus. É necessário que o paciente
                                    tenha ao menos 2 dias de sintomas para a
                                    realização do teste. */}
                                </p>
                            </Item>
                            <Item style={{maxWidth:'350px'}}>
                                <strong className="test-title-font-size"><mark className="test-type-mark-color">Teste de coronavírus anticorpos</mark></strong>
                                <p className="test-font-size">
                                    O teste rápido por sorologia realiza a detecção de
                                    anticorpos IgG/IgM e revela se uma pessoa teve ou
                                    não produção de anticorpos para o COVID-19.
                                    Através de uma pequena amostra de sangue para
                                    ser aplicada no dispositivo do teste. O resultado
                                    pode ser visto após 15 minutos. É indicado para
                                    que seja feito a partir do oitavo dia do início
                                    dos sintomas, quando os anticorpos já são mais
                                    detectáveis.
                                </p>
                            </Item>                           
                        </Conteiner>
                    </Item>         
                    <Item className="item-width test-display-inform">
                        <div style={{marginLeft:'30px', marginBottom:'80px'}}>
                            <Inform 
                                param2={ true }
                                param3={ true }
                                onClick1={ onClick1 } 
                                onClick2={ onClick2 } 
                                onClick3={ onClick3 } 
                                onClick4={ onClick4 }
                                onClick5={ onClick5 }
                            /> 
                        </div>
                        <GroupButtom column={true} onTestClick={ onTestClick } onWhatsClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}}/>
                    </Item>         
                </MainConteiner>
                                        
            </div>
            
        </>
        : <span/>
    )    
}

export default React.memo(TestType)